import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { posts } from '@/content/blog';
import { readingMinutes } from '@/lib/blogFormat';

const formatDate = (d: string) =>
  new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });

const Blog = () => (
  <>
    <Helmet>
      <title>Blog: Google Ads, Web Design & AI Automation Guides | Omnicraft</title>
      <meta name="description" content="Practical guides for US small businesses on Google Ads management, web design, n8n automation, Supabase and AI document extraction, from the Omnicraft team." />
      <link rel="icon" type="image/png" href="/logo.png" />
      <link rel="apple-touch-icon" href="/logo.png" />
    </Helmet>
    <section className="section-padding min-h-screen bg-gradient-to-b from-white to-slate-100 dark:from-slate-900 dark:to-slate-950">
      <div className="container-custom">
        <h1 className="mb-4 text-center font-bold text-3xl md:text-5xl">Guides for US small businesses</h1>
        <p className="mx-auto mb-12 max-w-2xl text-center text-lg text-slate-600 dark:text-slate-300">
          Straight answers on Google Ads, websites and AI automation: what things cost, what works, and what to skip.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article
              key={post.slug}
              className="relative flex flex-col h-full rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-7 shadow-lg transition-transform duration-200 hover:scale-[1.02]"
            >
              <span className="text-sm font-semibold uppercase tracking-wide text-primary">{post.category}</span>
              <h2 className="mt-2 text-xl md:text-2xl font-bold leading-snug text-slate-900 dark:text-white">
                {/* after:inset-0 stretches the link over the whole card, so any click on it opens the post */}
                <Link to={`/blog/${post.slug}`} className="after:absolute after:inset-0 after:rounded-2xl hover:underline">{post.title}</Link>
              </h2>
              <p className="mt-3 text-slate-700 dark:text-slate-300 leading-relaxed">{post.description}</p>
              <p className="mt-auto pt-5 text-sm text-slate-500 dark:text-slate-400">
                {post.author} · <time dateTime={post.date}>{formatDate(post.date)}</time> · {readingMinutes(post)} min read
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Blog;
